import React from 'react';

import { useGetMyIntroductions } from '@queries/introductions';
import { withAuthGate } from '@sunrise-ui/composites';
import { Loader, useAuthStore } from '@sunrise-ui/primitives';
import InboxIntroductionView from '@templates/InboxIntroductionView';

function DeniedIntrosScreen() {
  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingIntros, data: introductions } =
    useGetMyIntroductions({
      userId: currentUserId,
      state: 'denied',
    });

  if (isLoadingIntros) return <Loader size="large" />;

  return (
    <InboxIntroductionView intros={introductions ?? []} variant="denied" />
  );
}

export default withAuthGate(DeniedIntrosScreen);
